export enum JobFileEnum {
  FINAL_VIDEO = 'finalVideo.mp4',
  FINALE_AUDIO = 'translatedAudio.wav',
  ORIGINAL_VIDEO_CLEAN = 'videoClean.mp4',
  TRANSCRIPTION_TXT = 'segments_speaker_0.json',
  ORIGINAL_AUDIO = 'vocals.wav',
}
